/* eslint-disable max-len */
import { styled } from 'styled-components';
import {
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    DialogActions,
    Grid,
    Icon,
    Button,
    InputLabel,
    FormControl,
    MenuItem,
    Tabs,
    Tab,
    Box,
    Typography,
    Chip,
    Card,
    CardContent,
    TextField,
    CircularProgress,
    LinearProgress,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Divider,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { authAtom } from '../../../states/usuarios/AuthState';
import { ICv, IIdioma, IIdiomaConfig } from '../../../commons/types/crm';
import { useCurriculosActions } from '../../../states/curriculos/curriculos.actions';
import { useCurriculoActions } from '../../../states/curriculo/curriculo.actions';
import TableCrud from '../../../components/TableCrud/TableCrud';
import FeaturedIcon from '../../../assets/iconsUX/Featured icon.png';
import InputArquivo from '../../../components/InputArquivo';
import AlertComponent from '../../../components/Alert/Alert';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { SelectStato, TextFieldStato } from '../../../commons/styleds/styleds';
import EditIcon from '@mui/icons-material/Edit';
import { useConfigIdiomasActions } from '../../../states/configIdiomas/configIdioma.actions';
import dayjs from 'dayjs';
import { useTranslation } from '../../../commons/useTranslasion';
import { esES, ptBR } from '@mui/material/locale';

const CurriculoComponent: React.FC = () => {
    const { translate, language } = useTranslation();
    const lang = language ?? "pt-br";
    let locale = ptBR;
    switch (lang.slice(0, 2)) {
      case "es":
        locale = esES
        break;
    }

    const auth = useRecoilValue(authAtom);
    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [cvs, setCVs] = useState<ICv[]>([]);
    const [cv, setCV] = useState<ICv>();
    const [acaoEmEdicao, setAcaoEmEdicao] = useState<ICv>({});
    const [editAcao, setEditAcao] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const [idAtualizar, setIdAtualizar] = useState<number | undefined>(undefined);
    const [idioma, setIdioma] = useState<IIdiomaConfig>();
    const [nomeArquivo, setNomeArquivo] = useState('');
    const [arquivoUrl, setArquivoUrl] = useState('');
    const [idiomasSelect, setIdiomasSelect] = useState<IIdiomaConfig[]>([]);
    const [idiomaSelected, setIdiomaSelected] = useState<number>();
    const [idTemp, setIdTemp] = useState<ICv>({});
    const [idiomasConfig, setIdiomasConfig] = useState<IIdiomaConfig[]>([]);
    const configIdiomasActions = useConfigIdiomasActions();
    const cvActions = useCurriculosActions();


    const handleVisualizar = (cv: ICv) => {
        const fileUrl = cv.anexo;
        const fileName = cv.nomeCv?.toLowerCase() || cv.nome?.toLowerCase() || '';

        if (fileName.endsWith('.docx') || fileName.endsWith('.doc')) {
            try {

                const googleDocsUrl = `https://docs.google.com/viewerng/viewer?url=${encodeURIComponent(fileUrl)}&embedded=true`;
                window.open(googleDocsUrl, '_blank');
            } catch (error) {
                console.error(translate('erroAoAbrirDocumento'), error);
                toast.error(translate('naoFoiPossivelAbriOdocumento'));

                window.open(fileUrl, '_blank');
            }
        } else {

            window.open(fileUrl, '_blank');
        }
    };

    const handleEditar = (cv: ICv) => {
        setIdAtualizar(cv.id!);
        setIdioma(idiomasSelect.find((f) => f.id == cv.idIdioma));
        setIdiomaSelected(cv.idIdioma);
        setArquivoUrl(cv.anexo);
        setNomeArquivo(cv.nomeCv ?? '');
        setOpen(true);
    };


    const adicionarNaLista = () => {
        if (Number(auth?.id) <= 0) {
            toast.warn(translate('selecioneUmContato'));
            return;
        }

        cv!.nome = nomeArquivo;
        cv!.idioma = idiomasConfig.find((f) => f.id === idiomaSelected)?.nome;
        cv!.idIdioma = idiomaSelected;
        cv!.nomeCv = nomeArquivo;
        cv!.idContato = Number(auth?.id);

        if (idAtualizar && idAtualizar > 0) cv!.id = idAtualizar;

        cvActions.createFormData(cv!).then((data) => {
            cvActions
                .list(false, `?contatoId=${auth?.id}`)
                .then((resp: ICv[]) => {
                    setCVs(resp);
                    setIdioma(undefined);
                    setArquivoUrl('');
                    setNomeArquivo('');
                    setOpen(false);
                    toast.success(translate('cvSalvoComSucesso'));
                })
                .catch((err: any) => toast.warn(err));
        });
        setLoading(false);
    };

    const handleApagar = (obj: ICv) => {
        setIdTemp(obj);
        setOpenDialog(true);
    };

    useEffect(() => {
        if (!auth?.id) return;

        cvActions
            .list(false, `?contatoId=${auth?.id}`)
            .then((resp: ICv[]) => setCVs(resp))
            .catch((err: any) => toast.warn(err));

        setLoading(false);
    }, []);

    useEffect(() => {
        configIdiomasActions
            .list()
            .then((resp: any) => {
                setIdiomasConfig(resp);
            })
            .catch((err: any) => toast.warn(err));
    }, []);

    const handleClose = () => {
        setOpenDialog(false);
        setIdTemp({});
    };

    const handleSucess = () => {
        setOpenDialog(false);

        cvActions
            .delete(idTemp.id!)
            .then(() => {
                const sub = cvs.filter((f) => f.id !== idTemp.id);
                setCVs(sub);
                setIdTemp({});
            })
            .catch((e) => {
                console.error(e);
                toast.error(translate('erroAoApagar'));
            });
    };

    return (
        <>
            <Grid xs={12} md={12} sx={{ padding: '40px 0px 0px 0px' }}>
                <TableCrud
                    handleClickDeleteRow={handleApagar}
                    handleClickAdd={() => setOpen(true)}
                    labelTitle={translate('cvs')}
                    labelAddButton={translate('cvs')}
                    rows={cvs.map((row: ICv) => ({
                        id: row.id,
                        nome: row.nome ?? row.nomeCv,
                        anexo: (
                            <>
                                <Icon
                                    sx={{ cursor: 'pointer' }}
                                    onClick={() => handleVisualizar(cvs.find((f) => f.id === row.id!)!)}
                                    about={translate('visualizarArquivo')}
                                >
                                    {' '}<VisibilityIcon />{' '}
                                </Icon>

                                <Icon
                                    sx={{ marginLeft: '2px', cursor: 'pointer' }}
                                    onClick={() => handleEditar(cvs.find((f) => f.id === row.id!)!)}
                                    about={translate('editarArquivo')}
                                >
                                    <EditIcon />
                                </Icon>
                            </>
                        ),
                        idioma: row?.idIdiomaNavigation?.nome!,
                        data: `${dayjs(row.dtCadastro ?? row.dtAtualizacao).format('DD/MM/YYYY HH:mm')}`
                    }))}
                    columns={[
                        "nome",
                        "anexo",
                        "idioma",
                        "data"
                    ]}
                    columnsLabels={[
                        translate('currículo'),
                        translate('anexo'),
                        translate('idioma'),
                        translate('dataDeCadastro')
                    ]}
                    loadingGet={loading}
                />
            </Grid>


            <React.Fragment>
                <Dialog
                    open={open}
                    onClose={() => setOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    PaperProps={{
                        style: { borderRadius: 8 }
                    }}
                >
                    <DialogAlert>
                        <Grid sx={{ paddingLeft: "20px" }}>
                            <GridIcon>
                                <img src={FeaturedIcon} />
                            </GridIcon>
                        </Grid>
                        <DialogTitleDailog id="alert-dialog-title">
                            {translate('adicionarCv')}
                        </DialogTitleDailog>
                        <DialogContentDailog>
                            <DialogContentText id="alert-dialog-description">
                                <Grid container xs={12} sm={12} md={12} sx={{ display: 'flex', marginTop: '-10px', marginBottom: '20px' }}>
                                    <Grid xs={12} md={12}>
                                        <LabelInput>{translate('idioma')}</LabelInput>
                                        <FormControl required fullWidth  sx={{ margin: '20px 0px' }}>
                                            <SelectStato
                                                value={idiomaSelected}
                                                onChange={(e: any) => setIdiomaSelected(e.target.value)}
                                                required
                                                label=""
                                            >
                                                {idiomasConfig &&
                                                    idiomasConfig!.map((idiomaSelect: IIdiomaConfig, index: number) => (
                                                        <MenuItem value={idiomaSelect.id} key={index}>
                                                            {idiomaSelect.nome}
                                                        </MenuItem>
                                                    ))}
                                            </SelectStato>
                                        </FormControl>
                                    </Grid>

                                    <Grid container xs={7} sm={7} md={7} sx={{ display: 'flex', paddingRight: '5px' }}>
                                        <InputArquivo
                                            isEdit={editAcao}
                                            objOnEdit={acaoEmEdicao}
                                            setObjOnEdit={setAcaoEmEdicao}
                                            newObj={cv}
                                            setNewObj={setCV}
                                            nameFile={nomeArquivo}
                                            setNameFile={setNomeArquivo}
                                            urlFile={arquivoUrl}
                                            setUrlFile={setArquivoUrl}
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContentText>
                        </DialogContentDailog>
                        <DialogActions sx={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
                            <ButtonAlertClose  onClick={() => setOpen(false)}>
                                {translate('cancelar')}
                            </ButtonAlertClose>
                            <ButtonAlert variant="contained" onClick={adicionarNaLista} autoFocus>
                                {translate('btnSalvar')}
                            </ButtonAlert>

                        </DialogActions>
                    </DialogAlert>
                </Dialog>
            </React.Fragment>

            <AlertComponent
                open={openDialog}
                labelTitle={translate('desejaExcluirEsteCv')}
                labelDescription={translate('oCvSeráRemovidoPermanentementeDosSeusDadosCadastrados')}
                labelBtnClose={translate('cancelar')}
                labelBtnSucess={translate('excluir')}
                handleClose={handleClose}
                handleSucess={handleSucess}
            />

        </>
    );
};
                                
const GridItemCadastro = styled(Grid)`
  padding-bottom: 20px;
`;

export const GridItemCadastroBtnSalvar = styled(GridItemCadastro)`
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
`;

const ButtonAlertClose = styled(Button)`
width: 170px !important;
height: 44px !important;

font-family: Inter !important;
font-size: 16px !important;
font-weight: 600 !important;
line-height: 24px !important;
text-align: left !important;
text-underline-position: from-font !important;
text-decoration-skip-ink: none !important;

color: #414651 !important;
border: 1px solid #D5D7DA !important;
box-shadow: 0px 1px 2px 0px #0A0D120D !important;

border-radius: 8px !important;
margin-right: 10px !important;
`;

const ButtonAlert = styled(Button)`
width: 170px !important;
height: 44px !important;
padding: 10px 18px 10px 18px !important;
gap: 8px !important;
border-radius: 8px !important;
border: 1px 0px 0px 0px !important;
opacity: 0px !important;

background: #118BD7 !important;
border: 1px solid #118BD7 !important;
box-shadow: 0px 1px 2px 0px #0A0D120D !important;

`;

const DialogAlert = styled(Grid)`
width: 480px !important;
padding: 20px !important;
`;

const DialogTitleDailog = styled(DialogTitle)`
//styleName: Text lg/Semibold !important;
font-family: Inter !important;
font-size: 18px !important;
font-weight: 600 !important;
line-height: 28px !important;
text-align: left !important;
text-underline-position: from-font !important;
text-decoration-skip-ink: none !important;
color: #181D27 !important;
font-size: 22px !important;

`;

const DialogContentDailog = styled(DialogContent)`
//styleName: Text sm/Regular !important;
font-family: Inter !important;
font-size: 14px !important;
font-weight: 400 !important;
line-height: 20px !important;
text-align: left !important;
text-underline-position: from-font !important;
text-decoration-skip-ink: none !important;
color: #535862 !important;
`;

const GridIcon = styled(Grid)`
width: 60px !important;
height: 60px !important;
gap: 0px !important;
border-radius: 28px !important;
border: 8px 0px 0px 0px !important;
opacity: 0px !important;
Size="lg" !important;
Color="Warning" !important;
Theme="Light circle outline" !important;

display: flex !important;
justify-content: center !important;
align-items: center !important;
`;

const LabelInput = styled(InputLabel)`
//styleName: Text sm/Medium !important;
font-family: Inter !important;
font-size: 14px !important;
font-weight: 500 !important;
line-height: 20px !important;
text-align: left !important;
text-underline-position: from-font !important;
text-decoration-skip-ink: none !important;
margin-bottom: -15px !important;
margin-top: 20px !important;
`;

export default CurriculoComponent;
